import type { CatalogEntry } from '../games/catalog';
import { CATALOG, findGame } from '../games/catalog';
import popularData from '../games/popular.json';
import { similarGames } from '../games/similar';
import { GameTile } from './GameTile';

/** Picks for the "Play next" column: a few games like this one, then the most-played ones. */
export function playNextFor(entry: CatalogEntry, count = 12): CatalogEntry[] {
  const out = new Map<string, CatalogEntry>();
  for (const g of similarGames(entry, 4)) out.set(g.id, g);
  for (const id of popularData.popular) {
    const g = findGame(id);
    if (g && g.id !== entry.id) out.set(g.id, g);
  }
  for (const g of CATALOG) if (g.id !== entry.id) out.set(g.id, g);
  return [...out.values()].slice(0, count);
}

/** Column of games beside the one being played, on wide screens (like the big game sites). */
export function PlayNext({ entry }: { entry: CatalogEntry }) {
  return (
    <aside className="play-next" aria-labelledby="play-next-h">
      <h2 id="play-next-h">Play next</h2>
      <ul>
        {playNextFor(entry).map((g) => (
          <li key={g.id}>
            <GameTile game={g} index={CATALOG.indexOf(g)} />
          </li>
        ))}
      </ul>
    </aside>
  );
}
